"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setPageMeta = void 0;
var _reduxAct = require("redux-act");
var assignPageActionMeta = function assignPageActionMeta() {
  return {
    pageMeta: true
  };
};

// setPageMeta('/some-path', { title: '..', description: '...' });
var setPageMeta = (0, _reduxAct.createAction)('SET PAGE META', function (_ref) {
  var _ref$pathname = _ref.pathname,
    pathname = _ref$pathname === void 0 ? '' : _ref$pathname,
    _ref$pageMeta = _ref.pageMeta,
    pageMeta = _ref$pageMeta === void 0 ? {} : _ref$pageMeta;
  return {
    pathname: pathname,
    pageMeta: pageMeta
  };
}, assignPageActionMeta);
exports.setPageMeta = setPageMeta;